const LEARNING_AREAS = [
  {
    icon: 'ri-line-chart-line',
    title: 'Observability interpretation',
    desc: 'Learn to separate useful signals from noisy logs, metrics, and symptoms so you can focus on what matters first.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Failure classification',
    desc: 'Build the habit of identifying common production failure patterns such as authentication issues, dependency failures, and misconfigurations.',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Incident triage',
    desc: 'Improve your ability to judge impact, assign the right severity, and avoid overreacting to the wrong signal.',
  },
  {
    icon: 'ri-links-line',
    title: 'Dependency reasoning',
    desc: 'Understand how upstream and downstream dependencies influence outages, degraded behaviour, retries, and cascading failures.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Debugging mindset',
    desc: 'Practise making stronger first moves during incidents instead of losing time proving the wrong hypothesis.',
  },
  {
    icon: 'ri-repeat-line',
    title: 'Daily engineering habit',
    desc: 'Turn incident thinking into a repeatable routine through small daily reps that compound over time.',
  },
];

export default function WhatEngineersLearnSection() {
  return (
    <section className="py-24 border-t border-border-subtle">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-block text-xs font-mono uppercase tracking-widest text-accent mb-3">
            Learning outcomes
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-text-primary">
            What Engineers Learn From This
          </h2>

          <p className="text-text-secondary mt-3 max-w-2xl mx-auto text-sm leading-relaxed">
            Each daily challenge strengthens the judgement, pattern recognition, and operational
            thinking engineers need when real production incidents happen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {LEARNING_AREAS.map((item) => (
            <div
              key={item.title}
              className="bg-bg-panel border border-border-subtle rounded-xl p-6 hover:border-accent/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg border border-accent/30 bg-accent/5 text-accent mb-4">
                <i className={`${item.icon} text-xl`} />
              </div>

              <h3 className="text-lg font-semibold text-text-primary mb-2">
                {item.title}
              </h3>

              <p className="text-sm text-text-secondary leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-bg-panel border border-accent/20 rounded-2xl p-6 md:p-8">
          <p className="text-sm text-text-secondary text-center max-w-3xl mx-auto leading-relaxed">
            The value is not just in solving one challenge.<br /> It is in building faster recognition,
            better triage habits, and stronger engineering intuition through repetition.
          </p>
        </div>
      </div>
    </section>
  );
}